/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { IconButton, Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function RiskRulesView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        {' '}
        <div> </div> <div style={{ flex: '1' }}></div>{' '}
        <div style={{ display: 'flex', gap: '8px' }}>
          {' '}
          <button
            className="scp-2223d55"
            onClick={m.rulesLoadDefaults}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              padding: '7px 14px',
              borderRadius: '99px',
              border: '1px solid var(--l12)',
              background: 'transparent',
              color: 'var(--text-mid)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-sparkle" style={{ fontSize: '12px' }}></i>Load System Defaults
          </button>{' '}
          <button
            className="scp-84a7026"
            onClick={m.customRuleAdd}
            aria-label="Add a custom advisory rule"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '7px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
              background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
              color: 'var(--acc)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-plus" style={{ fontSize: '12px' }}></i>Add Rule
          </button>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '18px 20px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '11px' }}>
          {' '}
          <i className="ph ph-engine" style={{ fontSize: '18px', color: 'var(--muted)' }}></i>{' '}
          <div>
            <div style={{ fontSize: '13px', fontWeight: '500' }}>Automated Trade Engine</div>
            <div style={{ fontSize: '11px', color: 'var(--muted2)', marginTop: '2px' }}>
              Monitors positions every 7s and applies active position-level rules
            </div>
          </div>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <span
            style={dc.css(
              `font-size:10.5px;padding:4px 11px;border-radius:99px;border:1px solid var(--l10);color:${dc.s(m.engineStatusFg)}`,
            )}
          >
            {dc.t(m.engineStatus)}
          </span>{' '}
          <button
            className="scp-e4b4ff0"
            disabled
            aria-describedby="pf-engine-start-note"
            title="The engine runs server-side; its status here is reported, not commanded. Rules activate it by being active."
            aria-label="Start engine (not available — the engine is not commanded from here)"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '11.5px',
              fontWeight: '500',
              padding: '6px 15px',
              borderRadius: '99px',
              border: '1px solid color-mix(in srgb, var(--pos) 50%, transparent)',
              background: 'color-mix(in srgb, var(--pos) 8%, transparent)',
              color: 'var(--pos)',
              cursor: 'pointer',
            }}
          >
            <i className="ph ph-play" style={{ fontSize: '11px' }}></i>Start
          </button>{' '}
        </div>{' '}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginTop: '14px' }}>
          {' '}
          <div
            style={{
              background: 'transparent',
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              padding: '12px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Active rules
            </div>
            <div
              style={{
                fontSize: '19px',
                fontWeight: '600',
                marginTop: '4px',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {dc.t(m.activeRules)}
            </div>
          </div>{' '}
          <div
            style={{
              background: 'transparent',
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              padding: '12px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Actions taken
            </div>
            <div
              style={{
                fontSize: '19px',
                fontWeight: '600',
                marginTop: '4px',
                color: 'var(--pos)',
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              0
            </div>
          </div>{' '}
          <div
            style={{
              background: 'transparent',
              border: '1px solid var(--l8)',
              borderRadius: '11px',
              padding: '12px',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Last tick
            </div>
            <div style={{ fontSize: '19px', fontWeight: '600', marginTop: '4px', color: 'var(--faint)' }}>
              –
            </div>
          </div>{' '}
        </div>{' '}
        <div style={{ fontSize: '10.5px', color: 'var(--faint)', textAlign: 'center', marginTop: '10px' }}>
          Enable at least one position-level rule below to start the engine.
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '10px',
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--muted2)',
          fontWeight: '600',
        }}
      >
        <i className="ph ph-robot" style={{ fontSize: '13px' }}></i>Position-level rules — engine automated
        <div
          style={{ flex: '1', height: '1px', background: 'linear-gradient(90deg,var(--l10),transparent)' }}
        ></div>
      </div>{' '}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '12px' }}>
        {' '}
        {(m.rules ?? []).map((r, i37) => (
          <Fragment key={i37}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '11px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                {' '}
                <div
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '8px',
                    background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                    border: '1px solid color-mix(in srgb, var(--acc-fill) 25%, transparent)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 'none',
                  }}
                >
                  <i
                    className={`ph ${dc.s(r?.icon)}`}
                    style={{ fontSize: '15px', color: 'var(--acc-2)' }}
                  ></i>
                </div>{' '}
                <div style={{ flex: '1', minWidth: '0' }}>
                  <div style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(r?.name)}</div>
                  <div style={{ fontSize: '10.5px', color: 'var(--faint)', marginTop: '2px' }}>
                    {dc.t(r?.type)}
                    {' · Auto'}
                  </div>
                </div>{' '}
                <Toggle
                  trackBg={r?.trackBg}
                  knobBg={r?.knobBg}
                  knob={r?.knob}
                  onClick={r?.toggle}
                  aria-label={dc.a(r.toggleLabel ?? r.name ?? r.label ?? 'Toggle')}
                />{' '}
              </div>{' '}
              <div
                style={{
                  fontSize: '11px',
                  color: 'var(--muted)',
                  lineHeight: '1.55',
                  fontStyle: 'italic',
                  flex: '1',
                }}
              >
                {dc.t(r?.desc)}
              </div>{' '}
              <div
                style={{
                  background: 'transparent',
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  padding: '4px 12px',
                }}
              >
                {' '}
                {(r?.params ?? []).map((p, i38) => (
                  <Fragment key={i38}>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '6px 0',
                        fontSize: '11.5px',
                      }}
                    >
                      <span style={{ color: 'var(--muted2)' }}>{dc.t(p?.k)}</span>
                      <span style={{ fontVariantNumeric: 'tabular-nums', color: 'var(--text2)' }}>
                        {dc.t(p?.v)}
                      </span>
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {' '}
                <span
                  style={dc.css(
                    `font-size:10px;font-weight:500;padding:3px 10px;border-radius:99px;border:1px solid ${dc.s(r?.statusBd)};color:${dc.s(r?.statusFg)}`,
                  )}
                >
                  {dc.t(r?.status)}
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                <IconButton
                  icon="ph-pencil-simple"
                  hoverClass="scp-4f3e86a"
                  aria-label={'Edit ' + String(r?.name ?? '') + ' parameters'}
                  onClick={r?.edit}
                />{' '}
                <IconButton
                  icon="ph-trash"
                  hoverClass="scp-4f3e86a"
                  aria-label={
                    'Delete ' + String(r?.name ?? '') + ' (system rules toggle off rather than delete)'
                  }
                  aria-describedby="pf-system-rule-delete-note"
                  disabled
                  title="System rules toggle off rather than delete \u2014 the switch on the card is the control"
                />{' '}
              </div>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
        {(m.customRules ?? []).map((r, i39) => (
          <Fragment key={String(r['id'])}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '16px 18px',
                display: 'flex',
                flexDirection: 'column',
                gap: '11px',
              }}
              data-custom-rule={i39}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {' '}
                <div
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '9px',
                    background: 'var(--l5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--muted)',
                  }}
                >
                  <i className="ph ph-flag" style={{ fontSize: '15px' }}></i>
                </div>{' '}
                <div style={{ flex: '1', minWidth: '0' }}>
                  {' '}
                  <div style={{ fontSize: '12.5px', fontWeight: '600' }}>{dc.t(r['label'])}</div>{' '}
                  <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>
                    {dc.t(r['severityLabel'])}
                  </div>{' '}
                </div>{' '}
                <Toggle
                  aria-pressed={!!r['enabled']}
                  onClick={r['toggle'] as () => void}
                  trackBg={dc.s(r['trackBg'])}
                  knob={dc.s(r['knob'])}
                  knobBg={dc.s(r['knobBg'])}
                  aria-label={(r['enabled'] ? 'Disable ' : 'Enable ') + String(r['label'])}
                />{' '}
              </div>{' '}
              <div style={{ fontSize: '11px', color: 'var(--text-mid)', lineHeight: '1.6' }}>
                {dc.t(r['expression'])}
              </div>{' '}
              <div style={{ fontSize: '10px', color: 'var(--faint)' }}>{dc.t(r['firedNote'])}</div>{' '}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {' '}
                <span
                  style={dc.css(
                    `font-size:10px;font-weight:500;padding:3px 10px;border-radius:99px;border:1px solid ${dc.s(r['statusBd'])};color:${dc.s(r['statusFg'])}`,
                  )}
                >
                  {dc.t(r['status'])}
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                <IconButton
                  icon="ph-trash"
                  hoverClass="scp-4f3e86a"
                  aria-label={'Delete ' + String(r['label'])}
                  onClick={r['remove'] as () => void}
                />{' '}
              </div>{' '}
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>
      <span hidden id="pf-system-rule-delete-note">
        System rules toggle off rather than delete — the switch on the card is the control.
      </span>
      <span hidden id="pf-engine-start-note">
        The engine runs server-side; its status here is reported, not commanded. Rules activate it by being
        active.
      </span>
    </div>
  );
}
